export default class MessageDetails {
    /**
     * @type {string}
     * @memberof MessageDetails
     * @name appName
     */
    public appName: string;
    /**
     * @type {string}
     * @memberof MessageDetails
     * @name 内容
     */
    public content: string;
    /**
     * @type {string}
     * @memberof MessageDetails
     * @name 内容类型
     */
    public contentCategory: string;
    /**
     * @type {string}
     * @memberof MessageDetails
     * @name 消息ID
     */
    public messageId: string;
    /**
     * @type {string}
     * @memberof MessageDetails
     * @name 小程序行为
     */
    public microAppAction: string;
    /**
     * @type {string}
     * @memberof MessageDetails
     * @name PC端行为
     */
    public pcAction: string;
    /**
     * @type {boolean}
     * @memberof MessageDetails
     * @name 已读状态
     */
    public readState: boolean;
    /**
     * @type {string}
     * @memberof MessageDetails
     * @name 发送时间
     */
    public sendTime: string;
    /**
     * @type {string}
     * @memberof MessageDetails
     * @name 系统名称
     */
    public systemName: string;
    /**
     * @type {string}
     * @memberof MessageDetails
     * @name 标题
     */
    public title: string;
    constructor({
        appName = '',
        content = '',
        contentCategory = '',
        messageId = '',
        microAppAction = '',
        pcAction = '',
        readState = true,
        sendTime = '',
        systemName = '',
        title = ''
    } = {}) {
        this.appName = appName
        this.content = content
        this.contentCategory = contentCategory
        this.messageId = messageId
        this.microAppAction = microAppAction
        this.pcAction = pcAction
        this.readState = readState
        this.sendTime = sendTime
        this.systemName = systemName
        this.title = title
    }
}